import { action, createRequestTypes } from 'utils/actions'

export const PERFORMANCE_TICKET_DETAILS = createRequestTypes('PERFORMANCE_TICKET_DETAILS')

export const performanceTicketDetails = {
  request: performanceId => action(PERFORMANCE_TICKET_DETAILS.REQUEST, { performanceId }),
  success: (performanceId, response) => action(PERFORMANCE_TICKET_DETAILS.SUCCESS, { performanceId, response }),
  failure: (performanceId, error) => action(PERFORMANCE_TICKET_DETAILS.FAILURE, { performanceId, error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/tickets/tickets-actions.js
 **/